// extracted by mini-css-extract-plugin
module.exports = {"compContainer":"CompGrid-module--compContainer--2UG5N","container":"CompGrid-module--container--17nGF","header":"CompGrid-module--header--1u44y"};